"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.phoneMask = void 0;
const config_1 = require("./config");
const PasswordValidator = require('password-validator');
const minDateOfBirth = config_1.react_core_config.internalConfig.minDateOfBirth;
const maxDateOfBirth = config_1.react_core_config.internalConfig.maxDateOfBirth;
const passwordValidatorSchema = new PasswordValidator();
exports.phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
passwordValidatorSchema
    .is()
    .min(8)
    .is()
    .max(20)
    .has()
    .uppercase()
    .has()
    .lowercase()
    .has()
    .symbols()
    .has()
    .digits();
const validation = {
    emailValidationRegex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    phoneValidationRegex: /^$|^\d{10}$|^\([1-9]\d{2}\)\s(\d{3})-(\d{4})$/,
    passwordValidatorSchema,
    minDateOfBirth,
    maxDateOfBirth,
    maxNameLength: 30,
    stringAsSpace: /^[\s\S]*\S[\s\S]*$/,
    nameValidationRegex: /^[a-z ,.'‘’-]+$/i,
    usaOnlyZipcode: config_1.react_core_config.internalConfig.usaOnlyZipcode
};
exports.default = validation;
//# sourceMappingURL=validation.js.map